module.exports = __webpack_public_path__ + "img/img_tutorial_05.1f57841b.svg";